import {
    ACTIVATE_LEASE_URL,
    ADD_LEASE_CONTACT_URL,
    ADD_OR_DELETE_UNIT_URL, APPROVE_LEASE_TERMINATION_REQUEST_URL,
    CHG_CD_URL,
    CREATE_RSR_INVOICE_URL,
    DELETE_DRAFT_LEASE_URL,
    DELETE_LEASE_DOCUMENT,
    DELETE_RSR_DOCUMENT_URL,
    DOWNLOAD_LEASES_URL,
    EXPORT_LEASES_URL,
    GET_EDIT_UNIT_DETAILS_URL,
    GET_LEASE_CONTACTS_URL,
    GET_LEASE_DETAILS_URL,
    GET_RSRS_LIST_URL,
    GET_UNIT_METERS_URL,
    INCREMENT_RENT_URL,
    LEASE_FINANCIALS_URL,
    LEASE_NOTES_URL,
    LEASE_TERMINATION_ACCOUNT_URL,
    LEASE_TERMINATION_URL,
    LEASE_UNIT_CHARGES_URL,
    LES_PAY_MTH_URL,
    LES_TER_URL,
    LES_TYPE_URL,
    LIST_LEASES_URL,
    LIST_TERMINATED_LEASES_URL,
    OUTSTANDING_LEASE_INVOICES_CHARGES_URL, REJECT_LEASE_TERMINATION_REQUEST_URL, REMOVE_LEASE_CONTACT_URL,
    RESEND_LAST_INVOICE_URL,
    RESEND_LAST_RECEIPT_URL,
    RESEND_LAST_STATEMENT_URL,
    SAVE_LEASE_NOTE_URL,
    SAVE_LEASE_PAYMENT_URL,
    SAVE_LEASE_URL,
    SUSPEND_REACTIVATE_LEASE_URL,
    TOTAL_LEASES_URL,
    TOTAL_TERMINATED_LEASES_URL,
    UPDATE_LEASE_DEPOSIT_URL,
    UPDATE_LEASE_URL,
    UPDATE_RSR_URL,
    UPLOAD_LEASE_DOCUMENT,
    UPLOAD_RSR_INVOICE_DOCUMENT_URL,
    VIEW_RSR_URL,
    TOTAL_LEASE_FINANCIALS_URL,
    DELETE_RSR_URL,
    REJECT_RSR_URL
} from "../constants/url.constants"
import {serviceAPI, serviceAPIDownloadFile} from "./service"
import {handleErrorResponse} from "../actions/message"

//POST REQUEST
export const applyIncrement = (data) => {
    return serviceAPI.post(INCREMENT_RENT_URL, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export function rejectLeaseTerminationRequestData(data) {
    return serviceAPI
        .post(REJECT_LEASE_TERMINATION_REQUEST_URL, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export function approveLeaseTerminationRequestData(data) {
    return serviceAPI
        .post(APPROVE_LEASE_TERMINATION_REQUEST_URL, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}


//GET REQUEST
export const getLeasePaymentMethods = () => {
    return serviceAPI.get(LES_PAY_MTH_URL)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getOutstandingLeaseInvoicesCharges = (leaseId) => {
    let url = OUTSTANDING_LEASE_INVOICES_CHARGES_URL + leaseId
    return serviceAPI.get(url)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getLeaseTerminationAccount = (leaseId) => {
    let url = LEASE_TERMINATION_ACCOUNT_URL + leaseId
    return serviceAPI.get(url)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getLeaseFinancials = (leaseId, pageNo, rowsPerPage) => {
    let url = LEASE_FINANCIALS_URL + leaseId + "&pageNo=" + pageNo + "&rowsPerPage=" + rowsPerPage
    return serviceAPI.get(url)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getTotalLeaseFinancials = (leaseId) => {
    let url = TOTAL_LEASE_FINANCIALS_URL + leaseId
    return serviceAPI.get(url)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getLeases = (searchReference, searchTenant, searchUnit, pageNo, rowsPerPage, abortSignal={}) => {
    let url = LIST_LEASES_URL + searchReference + "&tenant=" + searchTenant + "&unit=" + searchUnit + "&pageNo=" + pageNo + "&rowsPerPage=" + rowsPerPage
    return serviceAPI.get(url, abortSignal)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getTerminatedLeases = (searchReference, searchTenant, pageNo, rowsPerPage) => {
    let url = LIST_TERMINATED_LEASES_URL + searchReference + "&tenant=" + searchTenant + "&pageNo=" + pageNo + "&rowsPerPage=" + rowsPerPage
    return serviceAPI.get(url)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getTotalLeases = (searchReference, searchTenant, searchUnit, abortSignal={}) => {
    let url = TOTAL_LEASES_URL + searchReference + "&tenant=" + searchTenant + "&unit=" + searchUnit
    return serviceAPI.get(url, abortSignal)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getTotalTerminatedLeases = (searchReference, searchTenant) => {
    let url = TOTAL_TERMINATED_LEASES_URL + searchReference + "&tenant=" + searchTenant
    return serviceAPI.get(url)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getLeaseNotes = (leaseId, pageNo) => {
    let url = LEASE_NOTES_URL + leaseId + "&pageNo=" + pageNo
    return serviceAPI.get(url)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getLeaseContacts = (leaseId) => {
    let url = GET_LEASE_CONTACTS_URL + leaseId
    return serviceAPI.get(url)
        .then((response) => {
            return response.data.contacts
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getLeaseDetails = (leaseId) => {
    let url = GET_LEASE_DETAILS_URL + leaseId
    return serviceAPI.get(url)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getEditUnitDetails = (leaseId) => {
    let url = GET_EDIT_UNIT_DETAILS_URL + leaseId
    return serviceAPI.get(url)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getLeaseTerms = () => {
    return serviceAPI.get(LES_TER_URL)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getUnitMeters = (unitId) => {
    return serviceAPI.get(GET_UNIT_METERS_URL + unitId)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getLeaseTypes = () => {
    return serviceAPI.get(LES_TYPE_URL)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const exportLeases = () => {
    return serviceAPIDownloadFile.get(EXPORT_LEASES_URL)
}

export const getLeaseChargeCodes = () => {
    return serviceAPI.get(CHG_CD_URL)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}


//POST REQUEST
export const saveLeaseNote = (data) => {
    return serviceAPI.post(SAVE_LEASE_NOTE_URL, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export function uploadLeaseDocument(data, leaseId) {
    let url = UPLOAD_LEASE_DOCUMENT + leaseId
    return serviceAPI
        .post(url, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export function deleteLeaseDocument(data, leaseId) {
    let url = DELETE_LEASE_DOCUMENT + leaseId
    return serviceAPI
        .post(url, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const addLeaseContact = (data) => {
    return serviceAPI.post(ADD_LEASE_CONTACT_URL, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const addOrDeleteUnit = (data) => {
    return serviceAPI.post(ADD_OR_DELETE_UNIT_URL, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const removeLeaseContact = (data) => {
    return serviceAPI.post(REMOVE_LEASE_CONTACT_URL, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const saveLeasePayment = (data) => {
    return serviceAPI.post(SAVE_LEASE_PAYMENT_URL, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const downloadLeases = (data) => {
    return serviceAPI.post(DOWNLOAD_LEASES_URL, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const leaseTermination = (data) => {
    return serviceAPI.post(LEASE_TERMINATION_URL, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const suspendReactivateLease = (data) => {
    return serviceAPI.post(SUSPEND_REACTIVATE_LEASE_URL, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const leaseUnitCharges = (data) => {
    return serviceAPI.post(LEASE_UNIT_CHARGES_URL, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const saveLeaseData = (data) => {
    return serviceAPI.post(SAVE_LEASE_URL, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const deleteDraftLease = (data) => {
    return serviceAPI.post(DELETE_DRAFT_LEASE_URL, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const activateLease = (data) => {
    return serviceAPI.post(ACTIVATE_LEASE_URL, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const updateActivateLease = (data) => {
    return serviceAPI.post(UPDATE_LEASE_URL, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const updateLeaseDeposit = (data) => {
    return serviceAPI.post(UPDATE_LEASE_DEPOSIT_URL, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const resendLastInvoice = (data) => {
    return serviceAPI.post(RESEND_LAST_INVOICE_URL, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const resendLastReceipt = (data) => {
    return serviceAPI.post(RESEND_LAST_RECEIPT_URL, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const resendStatement = (data) => {
    return serviceAPI.post(RESEND_LAST_STATEMENT_URL, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const createRSRInvoice = (data) => {
    return serviceAPI
        .post(CREATE_RSR_INVOICE_URL, data)
        .then((response) => {
        return response.data;
        })
        .catch((error) => {
        handleErrorResponse(error);
        });
}

export const uploadRSRInvoiceDocument = (data, rsrId) => {
  let url = UPLOAD_RSR_INVOICE_DOCUMENT_URL + rsrId;
  return serviceAPI
    .post(url, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      handleErrorResponse(error);
    });
}

export const deleteRSRDocument = (data, rsrId) => {
  let url = DELETE_RSR_DOCUMENT_URL + rsrId;
  return serviceAPI
    .post(url, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      handleErrorResponse(error);
    });
}

export const viewRSR = (rsrId) => {
  let url = VIEW_RSR_URL + rsrId;
  return serviceAPI
    .get(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      handleErrorResponse(error);
  })
}

export const updateRSR = (data, rsrId) => {
    let url = UPDATE_RSR_URL + rsrId;
    return serviceAPI
        .post(url, data)
        .then((response) => {
            return response.data;
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getRsrs = (leaseId) => {
    let url = GET_RSRS_LIST_URL + leaseId
    return serviceAPI
        .get(url)
        .then((response) => {
            return response.data;
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const deleteRSR = (rsrId) => {
    let url = DELETE_RSR_URL + rsrId;
    return serviceAPI
        .post(url)
        .then((response) => {
            return response.data;
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const rejectRSR = (rsrId) => {
    let url = REJECT_RSR_URL + rsrId;
    return serviceAPI
        .post(url)
        .then((response) => {
            return response.data;
        }).catch(error => {
            handleErrorResponse(error)
        })
}
